module.exports = __webpack_public_path__ + "img/safepal-w.4f3b84db.svg";